
// src/actions/s3upload.js

import AWS from 'aws-sdk'
import config from '../config'

export default function s3upload(credentials, video_id, s3_key, file, onprogress) {
  const s3 = new AWS.S3({
    accessKeyId: credentials.access_key_id,
    secretAccessKey: credentials.secret_access_key,
    sessionToken: credentials.session_token,
  })

  return new Promise((resolve, reject)=> {
    s3.upload({
      Bucket: credentials.bucket_name,
      Key: `${video_id}/${s3_key}`,
      Body: file,
    }, (err, data)=> {
      if (err)
        reject('error:s3upload')
      else
        resolve(video_id)
    }).on('httpUploadProgress', onprogress)
  })
}



// WEBPACK FOOTER //
// ./src/actions/s3upload.js